import { customDispatch } from "@affinity/Store/ServiceBase";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import values from "lodash/values"

// External parameters
type HandlerType = Handler<{
    value: boolean | undefined
}>;

export const SwitchAddressMode: HandlerType = ({dispatch, parameter: { value }}) => {
    (dispatch as customDispatch)({
        type: "Affinity/CreateAccount/SwitchAddressMode",
        value,
    });
};

export const Tracking: HandlerType = props => {
};

export const chain = [SwitchAddressMode, Tracking];

const setFuelProductQuantity = createHandlerChainRunner(chain, "SwitchAddressMode");
export default setFuelProductQuantity;